<template>
  <div>
    <form-wizard
      color="#9A3092"
      :title="null"
      :subtitle="null"
      shape="square"
      finish-button-text="Integrar"
      back-button-text="Voltar"
      next-button-text="Próximo"
      class="mb-3"
      @on-complete="formSubmitted"
    >
      <!-- accoint details tab -->
      <tab-content
        title="Informações da Loja"
      >
        <b-row>
          <b-col
            cols="12"
            class="mb-2"
          >
            <h5 class="mb-0">
              Informações da Loja
            </h5>
            <small class="text-muted">
              insira as informações básicas da sua loja
            </small>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Nome da Loja"
              label-for="name"
            >
              <b-form-input
                id="name"
                v-model="name"
                placeholder="insira aqui o nome da sua loja"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Link da Loja"
              label-for="url"
            >
              <b-form-input
                id="url"
                v-model="url"
                placeholder="https://loja.com.br"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Sigla da loja"
              label-for="abbr"
            >
              <b-form-input
                id="abbr"
                plaintext
                :value="abbr"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Plataforma da Loja"
              label-for="platform"
            >
              <v-select
                id="platform"
                v-model="sale_platform_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="platforms"
                :selectable="option => ! option.value.includes('select_value')"
                label="text"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>

      <!-- personal details tab -->
      <tab-content
        title="Configurações da Loja"
        :before-change="validationFormInfo"
      >
        <validation-observer
          ref="infoRules"
          tag="form"
        >
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Status para atendimento Humanizado"
                label-for="statuses"
              >
                <v-select
                  id="statuses"
                  v-model="contact_statuses"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="statuses"
                  multiple
                  :selectable="option => ! option.id.includes('select_value')"
                  label="status"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>

      <!-- address  -->
      <tab-content
        title="Integração da Loja"
        :before-change="validationFormAddress"
      >
        <validation-observer
          ref="addressRules"
          tag="form"
        >
          <!----Integração Tray-->
          <b-row v-if="sale_platform_id.value === '8'">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Integrando sua loja
              </h5>
              <small class="text-muted">Por favor, insira nos campos a baixo as informações fornecidas após instalar a ManyConvert na sua loja da Tray.</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="URL da API"
                label-for="address"
              >
                <b-form-input
                  id="address"
                  v-model="url_api"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Code"
                label-for="code"
              >
                <b-form-input
                  id="code"
                  v-model="code"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!----Integração vtex-->
          <b-row v-if="sale_platform_id.value === '4'">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Integrando sua loja
              </h5>
              <small class="text-muted">Por favor, insira nos campos a baixo as informações fornecidas no seu painel na vTex para finalizar a integração.</small>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Token"
                label-for="address"
              >
                <b-form-input
                  id="address"
                  v-model="url_api"
                  required
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Key"
                label-for="code"
              >
                <b-form-input
                  id="code"
                  v-model="code"
                  required
                />
              </b-form-group>
            </b-col>
          </b-row>

          <!----Integração Magazord-->
          <b-row v-if="sale_platform_id.value === '3'">
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Integrando sua loja
              </h5>
              <br>
              <small>Clique em integrar e, logo após, verifique os dados de integração da sua loja. </small>
            </b-col>
          </b-row>
        </validation-observer>
      </tab-content>
    </form-wizard>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
} from 'bootstrap-vue'
import { createStore } from '../../../functions/basics/stores'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    BFormInvalidFeedback,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      contact_statuses: '',
      sale_platform_id: '',
      name: '',
      abbr: '',
      url: '',
      superboleto: false,
      url_api: '',
      code: '',
      statuses: [
        { id: '1', status: 'Aguardando Pagamento' },
        { id: '2', status: 'Boleto Vencendo' },
        { id: '3', status: 'Boleto Vencido' },
        { id: '5', status: 'Pedido Recusado' },
        { id: '6', status: 'Abandono de Carrinho' },
        { id: '7', status: 'Enviar Rastreio' },
        { id: 'select_value', status: 'Select Value' },
      ],
      platforms: [
        { value: 'select_value', text: 'Select Value' },
        { value: '4', status: 'Pedido Pago' },
        { value: '1', text: 'Hotmart' },
        { value: '2', text: 'Monetizze' },
        { value: '3', text: 'Magazord' },
        { value: '4', text: 'Vtex' },
        { value: '5', text: 'Nuvemshop' },
        { value: '6', text: 'irroba' },
        { value: '7', text: 'Loja Integrada' },
        { value: '8', text: 'Tray' },
      ],
    }
  },
  watch: {
    name() {
      this.abbr = this.name.split(' ').filter((p, index) => index === 0 || p.length > 2).map(p => p[0]).join('.')
        .toUpperCase()
    },
  },
  methods: {
    async formSubmitted() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      const resp = await createStore(
        userData.mc_access_token,
        {
          name: this.name,
          abbr: this.abbr,
          url: this.url,
          contact_statuses: [1, 2],
          sale_platform_id: Number(this.sale_platform_id.value),
          url_api: this.url_api,
          code: this.code,
          superboleto: this.superboleto,
        },
      )

      if (resp === 200) {
        this.$swal({
          title: 'Loja Criada!',
          text: 'Sua loja foi criada com sucesso.',
          icon: 'success',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      } else {
        this.$swal({
          title: 'Error!',
          text: ' You clicked the button!',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        })
      }
    },
    validationForm() {
      return new Promise((resolve, reject) => {
        this.$refs.accountRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.infoRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormAddress() {
      return new Promise((resolve, reject) => {
        this.$refs.addressRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validationFormSocial() {
      return new Promise((resolve, reject) => {
        this.$refs.socialRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
